module.exports = __webpack_public_path__ + "static/media/Photo.869dd259.jpg";